export default {
  headingTextTransform: 'uppercase',
  modalColor: Styles.color.grey.five,
};
